const products = [
  {
    id: 1,
    name: "Ajwain",
    image: require("../images/spices/ajwain.png")
  },
  {
    id: 2,
    name: "Amchur Powder",
    image: require("../images/spices/amchur_powder.png")
  },
  {
    id: 3,
    name: "Biryani Masala",
    image: require("../images/spices/biryani_masala.png")
  },
  {
    id: 4,
    name: "Chaat Masala",
    image: require("../images/spices/chaat_masala.png")
  },
  {
    id: 5,
    name: "Saunf",
    image: require("../images/spices/saunf.png")
  },
  {
    id: 6,
    name: "Chai Masala",
    image: require("../images/spices/chai_masala.png")
  },
  {
    id: 7,
    name: "Coriander Powder",
    image: require("../images/spices/coriander_powder.png")
  },
  {
    id: 8,
    name: "Garam Masala",
    image: require("../images/spices/garam_masala.png")
  },
  {
    id: 9,
    name: "Jeera Powder",
    image: require("../images/spices/jeera_powder.png")
  },
  {
    id: 10,
    name: "Jeera Sabut",
    image: require("../images/spices/jeera_sabut.png")
  },
  {
    id: 11,
    name: "Kaali Mirch",
    image: require("../images/spices/kaali_mirch.png")
  },
  {
    id: 12,
    name: "Turmeric Powder",
    image: require("../images/spices/turmeric_powder.png")
  },
  {
    id: 13,
    name: "Yellow Heeng",
    image: require("../images/spices/yellow_heeng.png")
  },
  {
    id: 14,
    name: "Kashmiri Lal Mirch",
    image: require("../images/spices/kashmiri_lal_mirch.png")
  },
  {
    id: 15,
    name: "Red Chilli",
    image: require("../images/spices/red_chilli.png")
  },
  {
    id: 16,
    name: "Red Heeng",
    image: require("../images/spices/red_heeng.png")
  },
  {
    id: 17,
    name: "Sabji Masala",
    image: require("../images/spices/sabji_masala.png")
  },
  {
    id: 18,
    name: "Chaat Masala Sprinkler",
    image: require("../images/spices/chaat_masala_sprinkler.png")
  },
  {
    id: 19,
    name: "Kala Namak Sprinkler",
    image: require("../images/spices/kala_namak_sprinkler.png")
  },
  {
    id: 20,
    name: "Kali Mirch Sprinkler",
    image: require("../images/spices/kali_mirch_sprinkler.png")
  }
];

export default products;